import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/service/storage.service';
import { MobileMenuService } from 'src/app/service/mobile-menu.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent {
seleccionado: boolean = false;
esAdministrado: boolean = false;

  constructor(
    private storageService: StorageService,
    private route: Router,
    private storage: StorageService,
    public mobileMenu: MobileMenuService){

  }
  


  ngOnInit(): void {
    this.esAdministrado = this.storage.esAdministrador();

  }

  salir(){
    this.storageService.removeUsuarioStorage();
    this.route.navigate(['/login/ingresar']);
  }

}
